/**
 * 供应商详情 - SKU分布标签页
 */
import React from 'react';
import { Row, Col, Card, Statistic } from 'antd';
import { ShopOutlined } from '@ant-design/icons';

interface Supplier {
    active_sku_count?: number;
    inactive_sku_count?: number;
    total_sku_count?: number;
}

interface Props {
    supplier: Supplier;
}

const SKUTab: React.FC<Props> = ({ supplier }) => {
    return (
        <Row gutter={16}>
            <Col span={8}>
                <Card>
                    <Statistic
                        title="在售SKU数"
                        value={supplier.active_sku_count || 0}
                        prefix={<ShopOutlined />}
                        valueStyle={{ color: '#3f8600' }}
                    />
                </Card>
            </Col>
            <Col span={8}>
                <Card>
                    <Statistic
                        title="停用SKU数"
                        value={supplier.inactive_sku_count || 0}
                        prefix={<ShopOutlined />}
                        valueStyle={{ color: '#999' }}
                    />
                </Card>
            </Col>
            <Col span={8}>
                <Card>
                    <Statistic
                        title="总SKU数"
                        value={supplier.total_sku_count || 0}
                        prefix={<ShopOutlined />}
                        valueStyle={{ color: '#1890ff' }}
                    />
                </Card>
            </Col>
        </Row>
    );
};

export default SKUTab;
